import { api } from "../../../api/Middleware";
import { CUSTOMER_TAGS_URL, CUSTOMERS_URL } from "../../../api/Urls";

// Listar todos os clientes
export const listCustomers = async (params = {}) => {
  return await api.get(CUSTOMERS_URL, { params });
};

// Buscar cliente específico
export const getCustomer = async (id) => {
  return await api.get(CUSTOMERS_URL + `${id}/`);
};

// Criar novo cliente
export const createCustomer = async (data) => {
  return await api.post(CUSTOMERS_URL, data);
};

// Atualizar cliente existente
export const updateCustomer = async (id, data) => {
  return await api.put(CUSTOMERS_URL + `${id}/`, data);
};

// Atualizar parcialmente cliente
export const patchCustomer = async (id, data) => {
  return await api.patch(CUSTOMERS_URL + `${id}/`, data);
};

// Deletar cliente (soft delete)
export const deleteCustomer = async (id) => {
  return await api.delete(CUSTOMERS_URL + `${id}/`);
};

// Atualização em lote
export const bulkUpdateCustomers = async (data) => {
  return await api.post(CUSTOMERS_URL + "bulk_update/", data);
};

// Estatísticas dos clientes
export const getCustomerStats = async () => {
  return await api.get(CUSTOMERS_URL + "stats/");
};

// Exportar clientes
export const exportCustomers = async (params = {}) => {
  return await api.get(CUSTOMERS_URL + "export/", {
    params,
    responseType: "blob",
  });
};

// Adicionar tags a um cliente
export const addCustomerTags = async (customerId, tagIds) => {
  return await api.post(CUSTOMERS_URL + `${customerId}/add_tags/`, {
    tag_ids: tagIds,
  });
};

// Remover tags de um cliente
export const removeCustomerTags = async (customerId, tagIds) => {
  return await api.post(CUSTOMERS_URL + `${customerId}/remove_tags/`, {
    tag_ids: tagIds,
  });
};

// =============================
// CUSTOMER TAGS SERVICES
// =============================

// Listar todas as tags
export const listCustomerTags = async (params = {}) => {
  return await api.get(CUSTOMER_TAGS_URL, { params });
};

// Buscar tag específica
export const getCustomerTag = async (id) => {
  return await api.get(CUSTOMER_TAGS_URL + `${id}/`);
};

// Criar nova tag
export const createCustomerTag = async (data) => {
  return await api.post(CUSTOMER_TAGS_URL, data);
};

// Atualizar tag existente
export const updateCustomerTag = async (id, data) => {
  return await api.put(CUSTOMER_TAGS_URL + `${id}/`, data);
};

// Deletar tag
export const deleteCustomerTag = async (id) => {
  return await api.delete(CUSTOMER_TAGS_URL + `${id}/`);
};

// Estatísticas de uso das tags
export const getTagUsageStats = async () => {
  return await api.get(CUSTOMER_TAGS_URL + "usage_stats/");
};
